import { useContext } from 'react';
import { Navigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { AuthCards } from '@/components';
import { FirebaseContext } from '@/session/FirebaseContext';
import { AuthPageLayout } from '@/components/AuthCards/auth-ui';

export default function LogInPage() {
  const ctx = useContext(FirebaseContext);
  const [searchParams] = useSearchParams();

  const authUser = ctx.auth.currentUser ?? ctx.user;
  const redirectTo = searchParams.get('redirect_to');
  if (authUser) {
    if (!authUser.emailVerified) {
      const verifyPath = redirectTo
        ? `/verifyEmail?redirect_to=${encodeURIComponent(redirectTo)}`
        : '/verifyEmail';
      return <Navigate to={verifyPath} replace />;
    }
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return <Navigate to='/profile' replace />;
  }

  return (
    <AuthPageLayout backTo='/rules' backLabel='Return to rules'>
      <AuthCards initialMode='log-in' />
    </AuthPageLayout>
  );
}
